import { useState } from 'react';

import { Tabs } from '@/components/chariot-ui';
import { Modal } from '@/components/Modal';
import { Technology } from '@/types';

import { CpeStep, CpeTabContent } from './CpeTabContent';
import { UrlTabContent } from './UrlTabContent';

type ActiveTab = 'url' | 'cpe';

interface OsintConstantineModalProps {
  open: boolean;
  onClose: () => void;
}

const TAB_OPTIONS = [
  { label: 'By Repository URL', value: 'url' },
  { label: 'By Technology (CPE)', value: 'cpe' },
];

export function OsintConstantineModal({
  open,
  onClose,
}: OsintConstantineModalProps) {
  const [activeTab, setActiveTab] = useState<ActiveTab>('url');

  // Lifted for subtitle only
  const [cpeStep, setCpeStep] = useState<CpeStep>('create-technology');
  const [cpeTechnology, setCpeTechnology] = useState<Technology | null>(null);

  if (!open) return null;

  const subtitle =
    activeTab === 'url'
      ? 'Hunt for 0-days in a public repository'
      : cpeStep === 'create-technology'
        ? 'Step 1: Add a technology for research'
        : `Configure scan for ${cpeTechnology?.name || cpeTechnology?.product || cpeTechnology?.cpe}`;

  return (
    <Modal
      size="3xl"
      title="Research with Constantine"
      subtitle={subtitle}
      open={open}
      onClose={onClose}
      disableAutoFocus
      hideFooter
    >
      <div className="space-y-4">
        {/* Tab switcher */}
        <Tabs
          tabs={TAB_OPTIONS}
          selected={TAB_OPTIONS.find(t => t.value === activeTab) ?? null}
          onSelect={tab => setActiveTab(tab.value as ActiveTab)}
          variant="primary"
        />

        {/* URL tab content */}
        {activeTab === 'url' && <UrlTabContent onClose={onClose} />}

        {/* CPE tab content */}
        {activeTab === 'cpe' && (
          <CpeTabContent
            onClose={onClose}
            onStepChange={(step, technology) => {
              setCpeStep(step);
              setCpeTechnology(technology);
            }}
          />
        )}
      </div>
    </Modal>
  );
}
